<div class="wallets-wrapper">
  <div *ngFor="let key of getWalletNames(topWallets)" class="wallets-icon">
      <button type="button" (click)="selectWallet(key)" [class.active]="walletName.value==key" [disabled]="vars.isOrderLoading" mat-stroked-button>
        <span class="{{key}}" data-bg="/assets/images/wallets.png?w=auto"></span>
      </button>
  </div>
</div>

<div class="wallets-dropdown">
  <form [formGroup]="walletForm" (ngSubmit)="submitWallet()">
    <mat-form-field>
      <mat-select [formControl]="walletName" placeholder="Select Wallet" [disabled]="vars.isOrderLoading">
        <mat-option *ngFor="let key of getWalletNames(option)" [value]="key">
          {{option[key]}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div *ngIf="paymentUtil.utmProceedClicked">
      <app-utm-wallet-hundred type="payment" [donation]="cartDetails?.donated_amount"></app-utm-wallet-hundred>
    </div>
    <app-donate-btn label="proceed to contribute" [btnClass]="'submit-payment'" [amount]="cartDetails?.donated_amount" [isOrderLoading]="isOrderLoading || vars.isOrderLoading"></app-donate-btn>
  </form>
</div>
